import React from 'react'
import { FormattedMessage, useIntl } from 'react-intl'
import Section from './Section'
import SectionTitle from './SectionTitle'

const POINTS = ['canada', 'montreal', 'bilingual', 'smallTeam']

const TrustSection: React.FC = () => {
  const intl = useIntl()

  return (
    <Section bg="bg-background">
      <SectionTitle title={intl.formatMessage({ id: 'marketing.trust.title' })} />

      <div className="grid gap-6 sm:grid-cols-2">
        {POINTS.map((point) => (
          <div key={point} className="border-l-2 border-secondary pl-4">
            <h3 className="text-base font-semibold text-foreground">
              <FormattedMessage id={`marketing.trust.${point}.title`} />
            </h3>
            <p className="text-sm text-foreground-muted mt-1">
              <FormattedMessage id={`marketing.trust.${point}.text`} />
            </p>
          </div>
        ))}
      </div>

      <p className="mt-10 max-w-3xl text-sm text-foreground-muted">
        <FormattedMessage id="marketing.trust.honesty" />
      </p>
    </Section>
  )
}

export default TrustSection
